import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { API_BASE_URL } from '../data-access/api';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(
    @Inject(HttpClient) private http: HttpClient,
    @Optional() @Inject(API_BASE_URL) private baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = `${baseUrl}/profile`;
  }

  getUserSharedBrands(endpoint = '/user/me/shared') {
    return this.http.get(`${this.baseUrl}${endpoint}`);
  }

  checkIfUserProfileExists(endpoint = '/user/me/brand/me/exists') {
    return this.http.get(`${this.baseUrl}${endpoint}`);
  }

  linkProfile(request, endpoint = '/user/me/link') {
    return this.http.post(`${this.baseUrl}${endpoint}`, request);
  }

  setupProfile(request, endpoint = '/user/me/setup') {
    return this.http.post(`${this.baseUrl}${endpoint}`, request);
  }

  /**
   * Return null if photo not exists, backend returns bad request
   */
  getProfilePicture(endpoint = '/user/me/brand/me/picture') {
    return this.http
      .get(`${this.baseUrl}${endpoint}`, {
        responseType: 'blob',
      })
      .pipe(catchError(() => of(null)));
  }
}
